"use strict";

module.exports = ['Legacy Application Decodes', 'Application Decodes'];